module.exports = __webpack_public_path__ + "static/media/down_icon.cd005694.svg";